import { doRequest } from '@r1-frontend/do-request';
import { ISpecOffer, specOffers } from '@r1-frontend/api-domru/spec-offer/v1/spec-offers';

import { billingStateMap } from '~/src/features/specialOffersContainer/constants';
import { setIsLoadingOffers, setOffers } from '~/src/features/specialOffersContainer/store/actions';
import { TSpecOffer } from '~/src/features/specialOffersContainer/types';
import { TDispatch, TGetState } from '~/src/store';
import selectProviderId from '~/src/store/selectors/selectProviderId';

export const loadOffers = (force = false) => async(dispatch: TDispatch, getState: TGetState): Promise<void> => {
    const state = getState();
    const providerId = selectProviderId(state);
    const {
        auth: { clientPersonal },
        specOffers: { offers: storeOffers },
    } = state;

    if ((storeOffers.length && !force) || !clientPersonal) {
        return;
    }

    dispatch(setIsLoadingOffers(true));

    const response = await doRequest.specOffer<ISpecOffer[]>(
        specOffers(providerId, { isShowSpeedBonusesWithServiceEngineerVisit: 1 }),
    );

    if (response.isSuccess) {
        const offers = response.payload.map(({ state: stepId, ...offer }) => {
            const copy: TSpecOffer = {
                ...offer,
                state: stepId,
                billingState: billingStateMap[stepId] ?? 'viewed',
                isLoading: false,
                isConnecting: false,
            };

            /**
             * Ad hoc
             * TODO убрать, когда будет доработано на бэке
             */
            if (copy.billingState === 'pending') {
                copy.navigation = {
                    type: 'pendingConnection',
                    id: 0,
                    category: 'routers',
                };
            }

            return copy;
        });
        dispatch(setOffers(offers));
    }

    dispatch(setIsLoadingOffers(false));
};
